var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "claimWorkOrder" } }, [
    _c(
      "div",
      { staticClass: "yto-box y-pd-0 nCustomPrint" },
      [
        _c("quick-indemnity", {
          ref: "quickIndemnity",
          attrs: { realNameInfo: _vm.realNameInfo },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }